import React, { useState, useRef, useEffect } from 'react';

export default function DropdownCompetencia({ valor, opcoes, onChange }) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setAberto(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setAberto(!aberto)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)',
          color: 'var(--text)',
          fontSize: 'var(--font-base)',
          cursor: 'pointer',
          fontFamily: 'var(--font-family)',
        }}
      >
        <span>{valor?.nome || 'Selecionar...'}</span>
        <span style={{ fontSize: 'var(--font-xs)', color: 'var(--muted)' }}>
          {aberto ? '▲' : '▼'}
        </span>
      </button>

      {aberto && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          right: 0,
          minWidth: '180px',
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
          zIndex: 100,
          overflow: 'hidden',
        }}>
          {opcoes.map((opcao) => (
            <div
              key={opcao.id}
              onClick={() => { onChange(opcao); setAberto(false); }}
              style={{
                padding: '8px 16px',
                cursor: 'pointer',
                color: opcao.id === valor?.id ? 'var(--amber)' : 'var(--text)',
                fontSize: 'var(--font-base)',
                background: opcao.id === valor?.id ? 'rgba(245,158,11,0.1)' : 'transparent',
                transition: 'background var(--transition-fast)',
              }}
              onMouseEnter={(e) => {
                if (opcao.id !== valor?.id) e.currentTarget.style.background = 'var(--surface-2)';
              }}
              onMouseLeave={(e) => {
                if (opcao.id !== valor?.id) e.currentTarget.style.background = 'transparent';
              }}
            >
              {opcao.nome}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
